import React, { useEffect } from 'react';
import Navbar from '../../../components/Navbar';
import Story from '../components/Story';
import ProcessSection from '../components/ProcessSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import { ctaContent, footerContent, processContent, services } from '../content';
import './ConsultingLanding.css';
import '../../../components/Container.css';

const navbarLinks = [
  {
    href: '#services',
    label: 'Services',
    children: services.map((service) => ({ href: `#${service.id}`, label: service.title })),
  },
  { href: '#process', label: 'How We Work' },
  { to: '/platform', label: 'Platform' },
  { to: '/contact', label: 'Contact Us', isButton: true },
];

const footerSections = [
  {
    title: 'Services',
    links: services.map((service) => ({ href: `#${service.id}`, label: service.title })),
  },
  {
    title: 'Company',
    links: [
      { href: '#about', label: 'About Us' },
      { href: '#services', label: 'Services' },
      { href: '#process', label: 'How We Work' },
    ],
  },
  {
    title: 'Connect',
    links: [{ to: '/contact', label: 'Contact Us' }],
  },
];

const ConsultingLanding: React.FC = () => {
  useEffect(() => {
    const scrollToHash = () => {
      const id = window.location.hash.replace(/^#/, '');
      if (!id) return;
      document.getElementById(id)?.scrollIntoView({ behavior: 'auto', block: 'start' });
    };

    scrollToHash();
    window.addEventListener('hashchange', scrollToHash);
    return () => window.removeEventListener('hashchange', scrollToHash);
  }, []);

  return (
    <div className="consulting-app">
      <Navbar
        logo={{ src: '/orca-logo.png', text: 'Orca Labs' }}
        links={navbarLinks}
        overlay
      />

      <Story>
        <ProcessSection
          id="process"
          title={processContent.title}
          subtitle={processContent.subtitle}
          steps={processContent.steps}
        />

        <CTASection
          title={ctaContent.title}
          // description={ctaContent.description}
          actions={[{ label: ctaContent.actionLabel, to: '/contact', variant: 'primary' }]}
        />

        <Footer
          logo={{ src: '/orca-logo.png', text: 'Orca Labs' }}
          tagline={footerContent.tagline}
          copyright={footerContent.copyright}
          sections={footerSections}
        />
      </Story>
    </div>
  );
};

export default ConsultingLanding;
